import { getPageFrameData, PageFrame, PageFrameComponent } from '@zillow/page-frame-next/shopper-platform';
import { Heading, Page } from '@zillow/constellation-10';
import { RenterProfilePage } from '../components/RenterProfilePage';
import { RENTER_PROFILE_ROOT_ID } from '../constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withPageFrame = (Component: React.ComponentType<any>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const WrappedComponent = (props: any) => (
    <PageFrame
      pageFrameData={props.pageFrameData}
      components={[
        PageFrameComponent.HEADTAGS,
        PageFrameComponent.TOPNAV,
        PageFrameComponent.FOOTER,
        PageFrameComponent.REGLOGIN,
        PageFrameComponent.BODYSCRIPTS,
      ]}
      // Forces PFS core scripts to initialize in the browser
      startHydration={false}
    >
      <Component {...props} />
    </PageFrame>
  );
  WrappedComponent.displayName = `WithPageFrame(${Component.displayName || Component.name || 'Component'})`;

  // getInitialProps runs on server and/or client to fetch page frame props
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  WrappedComponent.getInitialProps = async (ctx: any) => {
    const pageFrameData = await getPageFrameData(ctx, {
      pfsHost: process.env.NEXT_PUBLIC_PAGE_FRAME_SERVICE,
      regionalizedLinks: false,
      useVisualRefreshTheme: true,
      includeZsg: false,
    });

    return { pageFrameData };
  };

  return WrappedComponent;
};

function RenterProfilePageContainer() {
  return (
    <div data-panda-theme="zillow" id={RENTER_PROFILE_ROOT_ID}>
      <Page.Root css={{ backgroundColor: 'bg.screen.softest' }}>
        <Page.Header>
          <Heading level={1}>Renter profile</Heading>
        </Page.Header>
        <Page.Content>
          <RenterProfilePage />
        </Page.Content>
      </Page.Root>
    </div>
  );
}

export default withPageFrame(RenterProfilePageContainer);
